/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentCompatibilityRadarScores model module.
 * @module model/AgentCompatibilityRadarScores
 * @version 1.0.0
 */
class AgentCompatibilityRadarScores {
    /**
     * Constructs a new <code>AgentCompatibilityRadarScores</code>.
     * @alias module:model/AgentCompatibilityRadarScores
     */
    constructor() { 
        
        AgentCompatibilityRadarScores.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentCompatibilityRadarScores</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentCompatibilityRadarScores} obj Optional instance to populate.
     * @return {module:model/AgentCompatibilityRadarScores} The populated <code>AgentCompatibilityRadarScores</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentCompatibilityRadarScores();

            if (data.hasOwnProperty('property_type')) {
                obj['property_type'] = ApiClient.convertToType(data['property_type'], 'Number');
            }
            if (data.hasOwnProperty('annual_income')) {
                obj['annual_income'] = ApiClient.convertToType(data['annual_income'], 'Number');
            }
            if (data.hasOwnProperty('financial_asset')) {
                obj['financial_asset'] = ApiClient.convertToType(data['financial_asset'], 'Number');
            }
            if (data.hasOwnProperty('investment_stage')) {
                obj['investment_stage'] = ApiClient.convertToType(data['investment_stage'], 'Number');
            }
            if (data.hasOwnProperty('area')) {
                obj['area'] = ApiClient.convertToType(data['area'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentCompatibilityRadarScores</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentCompatibilityRadarScores</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * 得意物件種別一致
 * @member {Number} property_type
 */
AgentCompatibilityRadarScores.prototype['property_type'] = undefined;

/**
 * 得意年収一致
 * @member {Number} annual_income
 */
AgentCompatibilityRadarScores.prototype['annual_income'] = undefined;

/**
 * 得意資産一致
 * @member {Number} financial_asset
 */
AgentCompatibilityRadarScores.prototype['financial_asset'] = undefined;

/**
 * 得意ステージ一致
 * @member {Number} investment_stage
 */
AgentCompatibilityRadarScores.prototype['investment_stage'] = undefined;

/**
 * 営業可能エリア一致
 * @member {Number} area
 */
AgentCompatibilityRadarScores.prototype['area'] = undefined;






export default AgentCompatibilityRadarScores;

